import { Select } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledSelect = styled(Select<string>)({
  padding: "4px",
})

export { StyledSelect }
